import React, { useContext, useEffect, useState } from 'react';
import ContentLoader from './components/ContentLoader/ContentLoader';
import createAppStateStore from './app-state-store';
import { cetraLightModeTheme } from './theme';
import { observer } from 'mobx-react-lite';
import UnauthenticatedAppWithStore from './react-core-lib/components/app/unauthenticated-app-with-store';
import './App.css';
import './console-overrides';

function App() {  

  useEffect(() => {
    console.log('App::useEffect');
  }, []);

  return (    
    <UnauthenticatedAppWithStore      
      UnauthenticatedComponent={ContentLoader}
      createAppStateStore={createAppStateStore}
      theme={cetraLightModeTheme}
      globalComponents={<></>}
    />
  );
}

export default observer(App);
